<template>
    <div>
        <div class="margin-top-10 display-flex justify-content-end">
            <!-- <div class="name-leson">
                <h4>
                    <strong>{{ dataElectronicLecture.name }}</strong>
                </h4>
            </div> -->
            <div class="wrap-btn-add-chapter">
                <a href="javascript:;" class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                    @click="handleAddLessonPlaning" v-if="isEdit == 1">
                    <img class="icon-plus" src="@/assets/img/plus.png" />
                    <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                    Thêm bài giảng điện tử
                </a>
            </div>
        </div>
        <!-- <img class="icon-down-arrow" src="@/assets/img/down-arrow.png" /> -->
        <div class="list-lesson">
            <draggable :list="listLessonPlaning" @change="onChangeDrag" @start="onDragStart" @end="onDragEnd">
                <transition-group type="transition">
                    <div v-for="(item, index) of listLessonPlaning" :key="index" class="row lesson-item margin-top-10">
                        <div class="col-md-6">
                            <img v-if="item.isDragable" class="icon-arrow" src="@/assets/img/arrow.png" />
                            <router-link class="wrap-item-electronic"
                                :to="{ path: '/kho-bai-giang/bai-giang-dien-tu', query: { id: item.electronicLectureId, name: item.name } }"
                                target="_blank">{{ item.name }}</router-link>
                        </div>
                        <div class="wrap-acion  justify-content-space-between display-flex" v-if="isEdit == 1">
                            <button v-if="!item.isDragable" type="button" @click="handleMoveLesson(item)"
                                class="btn btn-edit border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                :disabled="isLoading">
                                Sửa vị trí
                            </button>
                            <button type="button" @click="handleDeleteLesson(item)"
                                class="btn btn-delete border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                                :disabled="isLoading">
                                Xóa
                            </button>
                        </div>
                    </div>
                </transition-group>
            </draggable>

        </div>
        <ModalAddLessonPlaning @closeModal="closeModal" v-if="isOpenModalAddLessonPlaning" @handleDone="handleDone" />
        <ModelDeleteLessonPlaning v-if="isOpenModalDeleteLessonPlaning" :id="idSelected" @closeModal="closeModalDelete"
            @handleDeleteDone="handleDeleteDone" />
    </div>
</template>
<script>

import { GetListLessonPlaning, changeOrderlessonPlaning } from './../../../_api/LessonClassSchoolServices'
import ModelDeleteLessonPlaning from './ModelDeleteLessonPlaning'
import ModalAddLessonPlaning from './ModalAddLessonPlaning'
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../../../constants/constants_enum'
import draggable from 'vuedraggable'
export default {
    components: {
        ModelDeleteLessonPlaning,
        ModalAddLessonPlaning,
        draggable
    },
    props: {
        dataElectronicLecture: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        isEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isShowDragble: false,
            dragging: false,
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN,
            paramQueryData: {
                id: 0,
                type: ELECTRONIC_LECTURE_WAREHOUSE,
                keyword: '',
                pageIndex: 1,
                pageSize: 6,
            },
            isOpenModalAddLessonPlaning: false,
            listLessonPlaning: [],
            totalRecords: 0,
            isOpenModalDeleteLessonPlaning: false,
            idSelected: 0,
            isLoading: false
        }
    },
    mounted() {
        this.paramQueryData.id = this.$route.query.id
        this.getListLessonPlaning()
    },
    methods: {
        onChangeDrag(event) {
            console.log(event)
        },
        onDragStart(event) {
            this.dragging = true
        },
        onDragEnd(event) {
            let listOrder = []

            for (let i = 0; i < this.listLessonPlaning.length; i++) {
                const item = this.listLessonPlaning[i];
                listOrder.push(Number(item.orderNo))
            }

            listOrder.sort(function (a, b) {
                return a - b;
            })

            let listParams = []
            for (let i = 0; i < this.listLessonPlaning.length; i++) {
                const item = this.listLessonPlaning[i];
                listParams.push({ id: item.id, orderNo: listOrder[i] })
            }
            changeOrderlessonPlaning(listParams)

            for (let i = 0; i < this.listLessonPlaning.length; i++) {
                let element = this.listLessonPlaning[i];
                element.isDragable = false;
            }

            this.dragging = false
        },
        closeModalDelete() {
            this.isOpenModalDeleteLessonPlaning = false
        },
        handleDone() {
            this.getListLessonPlaning()
            this.closeModal()
        },
        handleDeleteDone() {
            this.getListLessonPlaning()
            this.closeModalDelete()
        },
        handleDeleteLesson(item) {
            this.idSelected = item.id
            this.isOpenModalDeleteLessonPlaning = true
        },
        handleMoveLesson(item) {
            item.isDragable = true
        },
        closeModal() {
            this.isOpenModalAddLessonPlaning = false
        },
        handleAddLessonPlaning() {
            this.isOpenModalAddLessonPlaning = true
        },
        getListLessonPlaning() {
            let self = this
            GetListLessonPlaning(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLessonPlaning = res.data
                    console.log(self.listLessonPlaning)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.icon-arrow {
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.margin-top-10 {
    margin-top: 20px;
}

.justify-content-space-between {
    justify-content: space-between
}

.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.wrap-item-electronic {
    color: #00f;
}
</style>
<style lang="scss" scoped>
.name-chapter {
    color: #626262;
}

.btn-delete {
    background-color: red;
    color: white;
    margin-left: 5px;
}

.btn-edit {
    background-color: #7ea8c7;
    color: rgb(70, 69, 69);
    margin-left: 5px;
}

.margin-top-10 {
    margin-top: 10px;
}

.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.justify-content-space-between {
    justify-content: space-between;
}
</style>